require('../../modules/es7.string.pad-end');
module.exports = require('../../modules/_core').String.padEnd;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/string/pad-end.js
// module id = 3062
// module chunks = 25